import React, { useState, MouseEvent } from "react";
import { AuthorizedLayout } from "../Layouts/AuthorizedLayout";
import {
  Box,
  Card,
  CircularProgress,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import BoxHeader from "../../Components/Common/Box/Boxheader";
import SearchandExport from "../../Components/Common/SearchandExport/SearchandExport";
import ActionIcon from "../../Assets/images/png/Action.png";
import { useNavigate } from "react-router-dom";
import InvoiceDialog from "./InvoiceDialog";

type Transaction = {
  TransactionId: string;
  OrderId: string;
  Date: string;
  CustomerName: string;
  PaymentMethod: string;
  Amount: string;
  PaidToProvider: string;
  GST: string;
  Status: string;
};
const getStatusColor = (status: string) => {
  let dotColor = "#6c757d";
  let textColor = "#6c757d";

  switch (status?.toLowerCase()) {
    case "pending":
      dotColor = "#FFA500"; // Orange
      textColor = "#FFA500";
      break;
    case "completed":
    case "accepted":
      dotColor = "#28a745"; // Green
      textColor = "#28a745";
      break;
    case "cancelled":
    case "rejected":
      dotColor = "#dc3545"; // Red
      textColor = "#dc3545";
      break;
    default:
      dotColor = "#6c757d"; // Gray
      textColor = "#6c757d";
  }

  return { dotColor, textColor };
};

const PaymentManagement = () => {
  const [loading, setLoading] = useState(false);
  const [tab, setTab] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedTransaction, setSelectedTransaction] = useState<null | Transaction>(null);
  const [openInvoice, setOpenInvoice] = useState(false);
  const navigate = useNavigate();

  const handleMenuOpen = (
    event: MouseEvent<HTMLButtonElement>,
    transaction: Transaction
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedTransaction(transaction);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const transactionData: Transaction[] = [
    {
      TransactionId: "TXN123456",
      OrderId: "ORD123456",
      Date: "22/10/2025",
      CustomerName: "Arun Kumar",
      PaymentMethod: "Credit Card",
      Amount: "₹5000",
      PaidToProvider: "₹3100",
      GST: "₹900",
      Status: "Pending",
    },
    {
      TransactionId: "TXN123457",
      OrderId: "ORD123457",
      Date: "21/10/2025",
      CustomerName: "Meena Rani",
      PaymentMethod: "UPI",
      Amount: "₹3000",
      PaidToProvider: "₹2000",
      GST: "₹540",
      Status: "Completed",
    },
    {
      TransactionId: "TXN123458",
      OrderId: "ORD123458",
      Date: "20/10/2025",
      CustomerName: "Ravi Shankar",
      PaymentMethod: "Debit Card",
      Amount: "₹7500",
      PaidToProvider: "₹5000",
      GST: "₹1350",
      Status: "Cancelled",
    },
    {
      TransactionId: "TXN123459",
      OrderId: "ORD123459",
      Date: "19/10/2025",
      CustomerName: "Priya Das",
      PaymentMethod: "Net Banking",
      Amount: "₹6500",
      PaidToProvider: "₹4000",
      GST: "₹1170",
      Status: "Completed",
    },
    {
      TransactionId: "TXN123460",
      OrderId: "ORD123460",
      Date: "18/10/2025",
      CustomerName: "Suresh Kumar",
      PaymentMethod: "Wallet",
      Amount: "₹4500",
      PaidToProvider: "₹2800",
      GST: "₹810",
      Status: "Pending",
    },
  ];

  const filteredData = transactionData.filter((item) =>
    item.CustomerName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <AuthorizedLayout>
      <Box sx={{ px: 2, py: 3, fontFamily: "Poppins, Semibold" }}>
        {loading && (
          <Box>
            <CircularProgress size={50} thickness={5} />
          </Box>
        )}

        <Card className="card-layout">
          <BoxHeader
            dashboard_name="Payment Management"
            tabs={["All Transactions"]}
            activeTab={tab}
            onTabChange={(newTab) => setTab(newTab)}
          />

          <SearchandExport
            searchPlaceholder="Search by Customer Name"
            onSearchChange={setSearchQuery}
          />

          {/* Transactions Table */}
          <Box sx={{ mt: 2, overflowX: "auto" }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell  className="table-header">Transaction ID</TableCell>
                  <TableCell  className="table-header">Order ID</TableCell>
                  <TableCell  className="table-header">Date</TableCell>
                  <TableCell  className="table-header">Customer Name</TableCell>
                  <TableCell  className="table-header">Payment Method</TableCell>
                  <TableCell  className="table-header">Amount(Gross)</TableCell>
                  <TableCell  className="table-header">Paid to Provider</TableCell>
                  <TableCell  className="table-header">GST</TableCell>
                  <TableCell  className="table-header">Status</TableCell>
                  <TableCell className="table-header ml-3">Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length > 0 ? (
                  filteredData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.TransactionId}</TableCell>
                      <TableCell>{row.OrderId}</TableCell>
                      <TableCell>{row.Date}</TableCell>
                      <TableCell>{row.CustomerName}</TableCell>
                      <TableCell>{row.PaymentMethod}</TableCell>
                      <TableCell>{row.Amount}</TableCell>
                      <TableCell>{row.PaidToProvider}</TableCell>
                      <TableCell>{row.GST}</TableCell>
                     <TableCell>
  {(() => {
    const { dotColor, textColor } = getStatusColor(row.Status);
    return (
      <Box display="flex" alignItems="center" gap={1}>
        <Box
          sx={{
            width: 10,
            height: 10,
            borderRadius: "50%",
            backgroundColor: dotColor,
          }}
        />
        <Typography sx={{ color: textColor, fontWeight: 500 }}>
          {row.Status}
        </Typography>
      </Box>
    );
  })()}
</TableCell>

                      <TableCell>
                        <Box display="flex" alignItems="center">
                            <Typography className="table-cell action">Action</Typography>
                          <IconButton onClick={(e) => handleMenuOpen(e, row)} className="mr-3">
                            <img src={ActionIcon} alt="action menu" />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <Typography>No transactions found.</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
        </Card>

        {/* Menu (kept separate) */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MenuItem
            onClick={() => {
              navigate(`/bookings/${selectedTransaction?.OrderId}`);
              handleMenuClose();
            }}
            sx={{color:'#398CDF'}}
          >
            Order Details
          </MenuItem>

          <MenuItem
            onClick={() => {
              setOpenInvoice(true);
              handleMenuClose();
            }}
             sx={{color:'#24BC94'}}
          >
            Invoice
          </MenuItem>
        </Menu>

        {/* Invoice Dialog (placed outside menu) */}
        <InvoiceDialog
          open={openInvoice}
          onClose={() => setOpenInvoice(false)}
          transaction={selectedTransaction}
        />
      </Box>
    </AuthorizedLayout>
  );
};

export default PaymentManagement;
